import Vue from "vue";
import axios from "axios";
export default {
  namespaced: true,
  state: () => ({
    loggedIn: false,
    redirectRoute: null,
    authToken: null,
    user: null,
    avatar: null,
    type: null,
    version: 0,
    locale: "ka",
  }),
  getters: {
    user: (state) => state.user,
    // TODO: some hardcode here
    age: (state) => {
      const defaultAge = 30;
      if (!state.user || !state.user.birthdate || state.user.birthdate === "") {
        return defaultAge;
      }
      const birthdateParts = state.user.birthdate.split("-");
      if (birthdateParts.length !== 3) {
        return defaultAge;
      }
      const birthdateYear = parseInt(birthdateParts[0]);
      const birthdateMonth = parseInt(birthdateParts[1]);
      const birthdateDate = parseInt(birthdateParts[2]);

      const todayYear = new Date().getFullYear();
      const todayMonth = new Date().getMonth();
      const todayDate = new Date().getDate();

      let yearsDiff = todayYear - birthdateYear;
      let monthsDiff = todayMonth - birthdateMonth;
      const daysDiff = todayDate - birthdateDate;
      if (daysDiff < 0) {
        monthsDiff -= 1;
      }
      if (monthsDiff < 0) {
        yearsDiff -= 1;
      }
      return yearsDiff;
    },
    name: (state) => {
      if (!state.user || !state.user.firstname) {
        return;
      }
      return `${state.user.firstname[state.user.language]} ${
        state.user.lastname[state.user.language]
      }`;
    },
    avatar: (state) => {
      if (!state.user) {
        return;
      }
      return `${state.avatar}?v=${state.version}`;
    },
    locale: (state) => {
      return state.user ? state.user.language : state.locale;
    },
    token: (state) => state.authToken,
    redirect: (state) => state.redirectRoute,
    type: (state) => state.type,
  },
  mutations: {
    setRedirect(state, route) {
      state.redirectRoute = route;
    },
    setToken(state, token) {
      state.authToken = token;
      if (token) {
        state.loggedIn = true;
      } else {
        state.loggedIn = false;
      }
    },
    setUser(state, user) {
      state.user = user;
      state.avatar = null;
      if (user) {
        state.type = user.type;
        state.avatar = user.photo;
      }
      state.version++;
    },
    setPasswordSet(state) {
      Vue.set(state.user, "password_set", true);
    },
    setLocale(state, locale) {
      state.locale = locale;
      localStorage.setItem("locale", locale);
    },
  },
  actions: {
    async fetch({ commit, dispatch }, id) {
      try {
        const response = await axios.get("/api/auth/user");
        commit("setUser", response.data.data);
      } catch (err) {
        commit("alert/setError", err, { root: true });
      }
    },
  },
};
